module.exports = {
      id: "women-home-usage",
      viewBox: "0 0 64.575 75.722",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#women-home",
      toString: function () {
        return this.url;
      }
    }